<template>
    <div  class="sphome" id="orderlist" >
        <div id="toolbar" class="tool_bar" ref="tool_bar">
            <ul class="ul_tools ">
                <li class="pad3">
                    <el-date-picker
                            size="mini"
                            v-model="start_time"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            type="date"
                            style="width: 130px"
                            :placeholder="$t('form_start_date')">
                    </el-date-picker>
                </li>
                <li class="pad3">
                    <el-date-picker
                            size="mini"
                            v-model="end_time"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            type="date"
                            style="width: 130px"
                            :placeholder="$t('form_end_date')">
                    </el-date-picker>
                </li>
                <li class="pad3">
                    <el-input class="mrl20" style="width: 200px"  v-model="vc_search" :placeholder="$t('purchaseOrder_please_enter_product_name/customer/order_number')" clearable size="mini"></el-input>
                </li>
                <li class="pad3">
                    <el-button class="mrl20" icon="el-icon-search" circle  size="mini" @click="gosearch"></el-button>
                </li>
            </ul>
            <ul class="editbutton ul_tools ">
                <li v-for="item in popList"
                    :key="item.index"
                    :title="item.title"
                    :id="item.name"
                    @click.stop="btn(item.name) ">
                    <el-divider v-if="item.class=='divider'" class="iconfont icon-button " direction="vertical"></el-divider>
                    <span v-else :class="item.class +' '+ item.pic+'  '"  :style="item.style">{{item.title}}</span>
                </li>
            </ul>
        </div>

        <div  class="content_">

            <el-popover ref="pop_ht"
                        placement="bottom-end"
                        popper-class="json_content"
                        trigger="click">
                <ht-list v-if="htpage" ref="jeditor" style="height:100%;width:100%;" @opendia="opendia" @closetent="closetent"></ht-list>
            </el-popover>

            <el-popover ref="pop_json"
                        placement="bottom-end"
                        popper-class="json_content"
                        trigger="click">
                <warehouse-applic  v-if="aplicpage" :appdata="appdata" ref="jeditor"  @opensq="opensq" style="height:100%;width:100%;" @closetent="closetent"></warehouse-applic>
                <!--<jeditor ref="jeditor"    :jMode="'tree'"  :jData="sets" style="height:100%;width:100%;" ></jeditor>-->
            </el-popover>

           <!-- <el-popover ref="pop_set"
                        placement="bottom-end"
                        popper-class="set_pop_content"
                        trigger="click">
                <spreadSet ref="spreadset"  :cell="cellInfo"   :acsheet="activeSheet"  style="height:100%;width:100%;" ></spreadSet>
            </el-popover>-->

            <div ref="spread" id="spreadContent"  class="sp_content" >
                <!--表单部分-->
                <div  class="tableHeight">
                    <el-table
                            v-loading="loading"
                            ref="table"
                            class="mrt10"
                            size="mini"
                            border
                            header-height="50px"
                            :data="tableData"
                            :height="tableHeight"
                            :header-cell-style="{background:'#eef1f6',color:'#000'}"
                            @row-click="rowClick"
                            highlight-current-row>
                        <el-table-column
                                type="index"
                                :label="$t('form_serial_number')"
                                width="45">
                        </el-table-column>
                        <el-table-column
                                prop="vc_fno"
                                :label="$t('form_contract_no')"
                                width="200">
                        </el-table-column>
                        <el-table-column
                                prop="vc_no"
                                :label="$t('form_order_number')"
                                width="200">
                        </el-table-column>
                        <el-table-column
                                prop="vc_pzname"
                                :label="$t('form_product_name')"
                                width="200">
                        </el-table-column>
                        <el-table-column
                                prop="vc_gysname"
                                :label="$t('purchaseOrder_supplier')"
                                width="200">
                        </el-table-column>
                        <el-table-column
                                prop="f_price"
                                :label="$t('purchaseOrder_unit_price_of_goods')"
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                prop="f_open_price"
                                :label="$t('purchaseOrder_product_unveiling_price')"
                                show-overflow-tooltip
                                width="90">
                        </el-table-column>
                        <el-table-column
                                prop="i_xtype"
                                :label="$t('purchaseOrder_nature_of_goods')"
                                width="100">
                            <template slot-scope="scope">
                                <span>{{scope.row.i_xtype==0?$t('form_domestic_sales'):$t('form_export')}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="f_num"
                                :label="$t('form_purchase_quantity')"
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                prop="f_sqnum"
                                :label="$t('purchaseOrder_apply_for_inventory_quantity')"
                                width="100">
                        </el-table-column>
                        <el-table-column
                                prop="vc_paytype"
                                :label="$t('saleOrder_payment_type')"
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                prop="vc_payway"
                                :label="$t('saleOrder_payment_method')"
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                prop="i_isdirexport"
                                :label="$t('purchaseOrder_is_it_targeted_procurement')"
                                width="98"
                                show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{scope.row.i_isdirexport?$t('form_correct'):$t('form_deny')}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="vc_dirgsname"
                                :label="$t('purchaseOrder_targeted_affiliated_companies')"
                                width="98"
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                prop="vc_bzname"
                                :label="$t('form_currency')"
                                width="80"
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                prop="f_rate"
                                :label="$t('purchaseOrder_settlement_rate')"
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                prop="vc_company"
                                :label="$t('form_company')"
                                width="200">
                        </el-table-column>
                        <el-table-column
                                prop="vc_bmname"
                                :label="$t('purchaseOrder_department')"
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                prop="dt_createtime"
                                :label="$t('purchaseOrder_registration_date')"
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                prop="vc_lruname"
                                :label="$t('form_input_person')"
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                fixed="right"
                                :label="$t('form_operate')"
                                width="100">
                            <template slot-scope="scope">
                                <el-button type="text" size="small" @click="detailClick(scope.row)">{{$t('button_edit')}}</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                            class="fr mrr9"
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page.sync="currentPage"
                            :page-sizes="[10, 15, 30]"
                            :page-size="pageSize"
                            layout="sizes, prev, pager, next"
                            :total="tableTotal">
                    </el-pagination>
                </div>
            </div>



            <!--dialog-->
            <div class="div cgdia">
                <el-dialog top="30px"
                        width="85%"
                        :title="title+'-'+$t('purchaseOrder_purchase_order')"
                        :visible.sync="dialogVisible"
                        :close-on-click-modal="false"
                        @close="cancelDialog('ht')"
                        v-if="dialogVisible">
                    <add-order ref="addorder" :application="application" @close="cancelDialog('ht')" @lookreport="lookreport"  @getPurchaseOrderList="getPurchaseOrderList"></add-order>
                </el-dialog>
            </div>
            <!--申请dialog-->
            <div class="div cgdia">
                <el-dialog
                        width="1000px"
                        :title="title_sq+'-'+$t('purchaseOrder_warehousing_application')"
                        :visible.sync="dialogVisible_sq"
                        :close-on-click-modal="false"
                        @close="cancelDialog('sq')"
                        v-if="dialogVisible_sq">
                    <add-appic ref="addappic" :application_sq="application_sq" @shuaxinboth="shuaxinboth" @close="cancelDialog('sq')" ></add-appic>
                </el-dialog>
            </div>
            <!--表报 -->
            <div>
                <reportdialog  ref="mydialog" ></reportdialog>
                <eDialog ref="eDialog" :activePage="activePage" ></eDialog>
            </div>
            <el-dialog
                    :style="{ maxHeight: maxDialogHeight + 'px', overflowY: 'auto' }"
                    class="div"
                    top="5vh"
                    width="90%"
                    :title="$t('purchaseOrder_cost_breakdown')"
                    :visible.sync="dialogVisible_cost"
                    :close-on-click-modal="false"
                    @close="cancelDialog('cost')"
                    v-if="dialogVisible_cost"
                    :append-to-body="true">
                <cost-list ref="costlist" :Data="rowData" @close="cancelDialog('cost')"></cost-list>
            </el-dialog>
        </div>

    </div>
</template>


<script>
    import * as API from "./api";
    import {mapActions} from "vuex";
    import htList from "./htList";
    import addOrder from "./addOrder";
    import warehouseApplic from "./warehouseApplic";
    import addAppic from "./addAppic";
    import {baseerp} from "@/utils/baseUrl";
    import reportdialog from "@/components/dialog"; // 错误dialog
    import eDialog from "@/components/eDialog"; // dialog
    import costList from './costList'
    export default {
        name: "orderList",
        components: {
            warehouseApplic,
            htList,
            addOrder,
            addAppic,
            reportdialog,eDialog,costList
        },
        data() {
            return {
                rowData:{},
                maxDialogHeight:0,
                dialogVisible_cost:false,
                activePage:"report/res/spread.vue",
                title_sq:"",
                dialogVisible_sq:false,
                application_sq:{},
                appdata:{},
                mid:0,
                application:{},
                i_htid:0,
                title:"",
                dialogVisible:false,
                htpage:false,
                aplicpage:false,
                tableData:[],
                pageSize:15,
                currentPage:1,
                tableTotal:0,
                highlightCurrentRow:null,
                tableHeight:0,
                baseerp:"",
                vc_search:"",
                start_time:"",
                end_time:"",
                popList:{
                    divider_op:{class:'divider'},
                    htlist:{name:"ht-ht",title:this.$t('purchaseOrder_contract_list'),data:1,style:'padding:5px;font-size:10px',pic:'hetongliebiao',class:'font-button iconfontcolor'},
                    datasource:{name:'ds-data',title:this.$t('purchaseOrder_warehousing_application'),data:1,style:'padding:5px;font-size:10px',pic:'wulitu_shujuku',class:'font-button iconfontcolor'},
                    //sx:{name:'sx-sx',title:'订货费用',data:1,style:'padding: 5px;font-size:10px',pic:'zhuticipeizhi',class:'font-button iconfontcolor'}
                    costlist:{name:'cost-list',title:this.$t('purchaseOrder_cost_breakdown'),data:1,style:'padding:5px;font-size:10px',pic:'costliebiao',class:'font-button iconfontcolor'},
                },
                loading:false,
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    // console.log(n,12312312)
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.baseerp=baseerp;
            this.getPurchaseOrderList();
            this.$nextTick(function () {
                //window.addEventListener('resize',this.heightAuto);
                //this.heightAuto();
                this.onResize();
            });
            //this.initSpread();
           //this.toolList=this.alignList.concat(this.valignList).concat(this.mergeList);
           //this.opList=Object.assign(this.fileList,this.obList);
            //$("#toolbar").find(".el-color-picker__trigger").css("border","0px");
            //$("#toolbar").find(".el-color-picker__icon").removeClass("el-icon-arrow-down");

        },
        beforeDestroy() {
            window.removeEventListener('resize', this.setDialogHeight);
        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            //报表
            async lookreport(id) {
                let arg={
                    id:id,
                };
                let loading =this.$loading({lock:true,text:this.$t('tips_loading_data_please_wait'),background:"rgba(0,0,0,0.5)"});
                //this.$refs.eDialog.showDialog({title:"报表",btn:{f:this.btn,l:{a:{title:"a",name:"a1"}}},parm:{type:'AttMonthRpt',mid:this.$route.meta.mid},w:800,h:600});
                document.addEventListener('click',function(e){
                    loading.close()
                })
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                this.$refs.eDialog.showDialog({title:this.$t('purchaseOrder_statistics'),parm:{type:'purchaseOrderDetail',mid:this.mid,arg:arg},w:1024,h:768});
                loading.close();

            },
            setDialogHeight() {
                //console.log(window.innerHeight,'window.innerHeight')
                this.maxDialogHeight = window.innerHeight;
                //const otherHeight =230;
                //this.tableHeight = window.innerHeight - otherHeight;
                //console.log( this.tableHeight,' this.tableHeight')
            },
            shuaxinboth(vc_no){
                //console.log("11111111111111")
                this.$refs.jeditor.sqlist(vc_no);
                this.$refs.jeditor.tableData=[];
                this.$refs.jeditor.currentPage=1;
                //this.getPurchaseOrderList();
            },

            opensq(data,type){
                if(type=="add"){
                    this.application_sq={
                        data:data,
                        title:this.$t('button_newly_added'),
                        titleID:"addNew",

                    };
                    this.title_sq=this.$t('button_newly_added');
                    this.dialogVisible_sq=true;
                }else if(type=="edit"){
                    this.application_sq={
                        vc_no:data.vc_no,
                        i_id:data.i_id,
                        title:this.$t('button_edit'),
                        titleID:'edit',

                    };
                    this.title_sq=this.$t('button_edit');
                    this.dialogVisible_sq=true;
                }

            },

            closetent(page){
                if(page=='ht'){
                    $(".hetongliebiao").removeClass("font-checked");
                    this.$refs.pop_ht.showPopper =false;
                    this.htpage=false;
                }else if(page=="applic"){
                    $(".wulitu_shujuku").removeClass("font-checked");
                    this.$refs.pop_json.showPopper =false;
                    this.aplicpage=false;
                }
            },

            gosearch(){
                //console.log("htpage",this.htpage);
                if(!this.htpage){
                    this.i_htid=0;
                }
                //console.log("start_time",this.start_time);
                //console.log("end_time",this.end_time);
                //console.log("vc_search",this.vc_search);
                this.currentPage=1,
                this.tableData=[];
                this.getPurchaseOrderList();
            },

            detailClick(row){
                //console.log("row",row)
                this.application={
                    i_id:row.i_id,
                    i_type:row.i_type,
                    i_isforeign:row.i_isforeign,
                    title:this.$t('button_edit'),
                    titleID:'edit',
                };this.title=this.$t('button_edit');
                this.dialogVisible=true;

            },

            opendia(data,type){
                //console.log("合同列表数据",data);
                //console.log("type",type);
                this.i_htid=data.htid;
                if(type=="add"){
                    this.application={
                        data:data,
                        title:this.$t('button_newly_added'),
                        titleID:"addNew",
                    };
                    this.title=this.$t('button_newly_added');
                    this.dialogVisible=true;
                }else{
                    this.getPurchaseOrderList();
                }
            },

            //关闭dialog
            cancelDialog(type){
                //console.log("guanleeeeeeeeeeeeeeeeeeeee")
                if(type=="ht"){
                    this.application={};
                    //this.$refs.addorder.formData={};
                    this.dialogVisible=false;
                    //this.highlightCurrentRow=false;
                }else if(type=="sq"){
                    this.application_sq={};
                    this.dialogVisible_sq=false;
                    //this.highlightCurrentRow=false;
                }else if(type=="cost"){
                    this.rowData={};
                    this.dialogVisible_cost=false;
                    $(".costliebiao").removeClass("font-checked");
                    //this.highlightCurrentRow=false;
                }
                $(".editbutton").removeClass("font-disable");
            },

            handleSizeChange(val){
                //console.log(val,"page_count");
                this.pageSize=val;
                this.currentPage=1;
                ///调用列表接口
                this.getPurchaseOrderList();
            },
            handleCurrentChange(val){
                //console.log(val,"page_size");
                this.currentPage=val;
                ///调用列表接口
                this.getPurchaseOrderList();
            },

            //拿到当前行数据
            rowClick(row){
                this.highlightCurrentRow=row;
                this.$refs.table.setCurrentRow(this.highlightCurrentRow);
                this.appdata={
                    vc_orderno:row.vc_no,
                    row:row,
                };
                //console.log(row,"row");

            },

            //列表接口
            async getPurchaseOrderList(pageSize){
                this.loading=true;
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    //console.log("///")
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                };
                //console.log("mid",this.mid)
                if(pageSize!=undefined) {
                    //console.log(pageSize,"addddd")
                    this.currentPage=pageSize;
                }
                let param = {
                    start_time:this.start_time,
                    end_time:this.end_time,
                    vc_search:this.vc_search,
                    page_count:this.pageSize,
                    page_size:this.currentPage,
                    i_htid:this.i_htid,
                    i_mid:this.mid,
                };
                //console.log("orderparam",param);
                let res = await API.getPurchaseOrderList(param);
                if (res.code == 1) {
                    this.loading=false;
                    this.tableData=res.data;
                    this.tableTotal=res.total;
                    if(res.total!=0){
                        this.appdata={
                            vc_orderno:this.tableData[0].vc_no,
                            row:this.tableData[0],
                        };
                    }
                    /*this.$nextTick(()=>{
                        this.$refs.table.setCurrentRow(this.tableData[0])
                    })*/
                    this.setDialogHeight();
                    window.addEventListener('resize', this.setDialogHeight);
                } else if (res.code == -2) {
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },

            heightAuto(){
                this.tableHeight = window.innerHeight - this.$refs.table.$el.clientTop -236;
                //console.log("this.tableHeight-sp_content",this.tableHeight);
                //console.log("this.$refs.table.$el.clientTop",this.$refs.table.$el.clientTop);
                $(".sp_content").height(this.tableHeight);
            },

            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#orderlist").height(n.h);
                $("#orderlist").width(n.w);
                this.tableHeight= n.h-80

                //console.log(this.tableHeight,"????????????????")
                //$(".sp_content").height($(".sphome").height()*1 -  $("#toolbar").height()*1);
                //console.log("sp_content-height",$(".sp_content").height)
                //this.tableHeight = $(".sp_content").height
            },

            btn(id){
                if(id==undefined) return;
                let id_family=id.split("-");
                //console.log("id_family",id_family);
                let sid=id_family[1];
                switch (id_family[0]) {
                    /*case 'zitijiacu':

                        this.font.fontWeight=$("#zitijiacu").is(".font-checked")?'normal':'bold';
                        $("#zitijiacu").toggleClass("font-checked");
                        this.setFont('font-weight','fontWeight');
                        break;
                    case 'zitixieti':

                        this.font.fontStyle=$("#zitixieti").is(".font-checked")?'normal':'italic';
                        $("#zitixieti").toggleClass("font-checked")
                        this.setFont('font-style','fontStyle');
                        break;
                    case 'border':
                        this.setBorder(sid);
                        break;
                    case 'line':
                        let oldid= $("#lineselect").attr("value");
                        $("#lineselect").removeClass(this.lineMenu[oldid].pic);
                        $("#lineselect").addClass(this.lineMenu[sid].pic);
                        $("#lineselect").attr("value",sid);
                        break;
                    case 'align':
                        this.setStyle('hAlign',sid*1);
                        break;
                    case 'file':
                        this.setFile(sid);
                        break;

                    case 'page':
                        this.setPage(sid);
                        break;
                    case 'valign':
                        this.setStyle('vAlign',sid*1);
                        break;
                    case 'merge':
                        this.mergeCells();
                        break;
                    case 'unmerge':
                        this.unmergeCells();
                        break;
                    case 'clear':
                        let sheet= this.cellrange.sheet;
                        if(this.picObj.selected)
                        { sheet.pictures.remove(this.picObj.name);
                            this.picObj.selected=false;}
                        else {
                            this.unmergeCells();
                            sheet.suspendPaint();
                            this.cellrange.clear(GC.Spread.Sheets.StorageType.data);
                            this.cellrange.clear(GC.Spread.Sheets.StorageType.style);
                            this.cellrange.clear(GC.Spread.Sheets.StorageType.tag);
                            this.cellrange.clear(GC.Spread.Sheets.StorageType.comment);
                            this.cellrange.clear(GC.Spread.Sheets.StorageType.sparkline);
                            sheet.resumePaint();
                        }
                        break;
                    case 'table':
                        console.log(this.cellInfo);
                        let i=0;
                        this.cellrange.sheet.tables.all().forEach(function(table){
                            let t=parseInt(table.name().replace('Table',''));
                            if (t>i) i=t;

                        });
                        var tableStyle = GC.Spread.Sheets.Tables.TableThemes.light1;
                        var table = this.cellrange.sheet.tables.add('Table'+(i+1), this.cellrange.row,this.cellrange.col,this.cellrange.rowCount,this.cellrange.colCount, tableStyle);
                        break;
                    case 'image':
                        this.$refs.upload_pic.dispatchEvent(new MouseEvent('click'));
                        break;
                    case 'freeze':
                        this.cellrange.sheet.options.frozenlineColor=this.linecolor;
                        this.cellrange.sheet.frozenRowCount(this.cellrange.sheet.getActiveRowIndex());
                        this.cellrange.sheet.frozenColumnCount(this.cellrange.sheet.getActiveColumnIndex());
                        break;
                    case 'collect_expend':
                        if($("#collect_expend").hasClass("icon-jiantou_liebiaoxiangzuo")) {

                            $("#collect_expend").removeClass("icon-jiantou_liebiaoxiangzuo");
                            $("#collect_expend").addClass("icon-jiantou_liebiaoxiangyou");
                            this.$parent.btn('collect');
                        }
                        else
                        {
                            $("#collect_expend").removeClass("icon-jiantou_liebiaoxiangyou");
                            $("#collect_expend").addClass("icon-jiantou_liebiaoxiangzuo");
                            this.$parent.btn('expend');
                        }
                        break;
                    case 'edit_view':
                        if(!$(".editbutton").hasClass("font-disable")) {
                            this.spreadData.template=this.spread.toJSON();
                            this.spreadData.set=this.$refs.jeditor.getJsonData();
                            this.$parent.btn('run');
                        }
                        else
                        {
                            $(".editbutton").removeClass("font-disable")
                            $("#edit_view").removeClass("icon-yulan1");
                            $("#edit_view").addClass("icon-yulan");
                            this.openSpread();
                        }
                        break;*/
                    case 'ds':

                        if($(".wulitu_shujuku").hasClass("font-checked"))
                        {
                            $(".wulitu_shujuku").removeClass("font-checked");
                            this.$refs.pop_json.showPopper =false;
                            this.aplicpage=false;
                        }
                        else {
                            $(".wulitu_shujuku").addClass("font-checked");
                            this.$refs.pop_json.showPopper =true;
                            this.aplicpage=true;
                        }
                        break;
                    /*case 'sx':

                        if($(".zhuticipeizhi").hasClass("font-checked"))
                        {
                            $(".zhuticipeizhi").removeClass("font-checked");
                            this.$refs.pop_set.showPopper =false;

                        }
                        else {
                            $(".zhuticipeizhi").addClass("font-checked");
                            this.$refs.pop_set.showPopper =true;

                        }
                        break;*/
                    case 'ht':

                        if($(".hetongliebiao").hasClass("font-checked"))
                        {
                            $(".hetongliebiao").removeClass("font-checked");
                            this.$refs.pop_ht.showPopper =false;
                            this.htpage=false;
                        }
                        else {
                            $(".hetongliebiao").addClass("font-checked");
                            this.$refs.pop_ht.showPopper =true;
                            this.htpage=true;
                        }
                        break;

                    case 'cost':

                        if($(".costliebiao").hasClass("font-checked"))
                        {
                            $(".costliebiao").removeClass("font-checked");
                            this.dialogVisible_cost=false;
                            this.rowData={};
                        }
                        else {
                            if(!this.highlightCurrentRow || Object.keys(this.highlightCurrentRow).length === 0){
                                this.$message.warning(this.$t('purchaseOrder_no_procurement_orders_have_been_selected'))
                                return
                            }
                            $(".costliebiao").addClass("font-checked");
                            this.dialogVisible_cost=true;
                            this.rowData={
                                type:'purc',
                                row:this.highlightCurrentRow,
                            };
                        }
                        break;

                    default: break;
                }
            },
        },
    }
</script>

<style  lang="scss" >
    //css
    //弹窗窗口
    .cgdia {
        //弹出层里内容 样式
        .el-dialog__body {
            /*max-height: 70vh !important;*/
            overflow-y: auto;
            /*padding: 0 20px 0 20px;*/
        }
    }
    /deep/.ordercgdia .el-dialog__wrapper{
        z-index:2026 !important;
    }

    .el-dialog__headerbtn .el-dialog__close{
        color: white;
    }
    .el-dialog__title{
        color: white;
    }
    .el-dialog__body{
        padding: 10px 20px;
    }
    .mrr9{
        margin-right: 9px;
    }
    .fr{
        float: right;
    }
    .pad3{
        padding: 3px;
    }

    .flex{
        display: flex;
    }
    .mrl20{
        margin-left: 20px;
    }

    .ul_tools {
        display: flex;
        float: left;
    }

    .sphome {
        padding: 0px 9px;
        margin-top: 0px;
        height:100% ;
        width: 100%;
    }

    .tool_bar {
        position: relative;
        float: left;
        //height: 40px;
        width:100%;
        border-bottom: 1px solid #d5d7da;
        z-index: 100;
    }

    .content_ {
        position: relative;
        margin: 0;
        padding: 0;
        width: 100%;
        height: calc(100% - 40px);
        overflow: hidden;
    }
    .content_ .json_content {
        position: absolute;
        margin: 0;
        padding: 0;
        left:calc(100% - 625px);
        width: 600px;
        color: black;
        background: white;
        //color: #774917;
        //background: #efefef;
        //height: calc(100% - 20px);
        height: calc(100% - 55px);
        /*opacity: 0.97;*/
        overflow: hidden;
    }
    .set_pop_content {
        position: absolute;
        margin: 0;
        padding: 0;
        left:calc(100% - 325px);
        width: 300px;
        color: #774917;
        background: #a3abb8;
        /*height: 400px;*/
        opacity: 0.8;
        overflow: hidden;
    }
    .sp_content {
        position: relative;
        margin: 0;
        padding: 0;
        //border: 3px solid #872519;
        width: 100%;
        height: calc(100% - 0px);
        overflow: hidden;
    }
    .icon-button {
        margin-top:5px;
        padding: 2px 0px;
        color: #4b7476;
        outline: none;
        cursor: pointer;
        text-align: center;
        line-height:36px;

    }
    .icon-menu {
        color: #257e6c;
        outline: none;
        font-size: 24px;
    }
    .icon-button:hover {
        background: #d3d3d3;

    }
    .font-button {
        margin-top:5px;
        padding: 5px 5px;
        color: #016277;
        font-size: 14pt;
        outline: none;
        cursor: pointer;
        text-align: center;
        line-height:36px;

    }
    .font-checked {
        background: #f6e3ac;

    }
    .font-button:hover {
        background: #babdbf;
        pointer-events:auto;
    }
    .font-disable {
        opacity: 0.5;
        pointer-events:none;
    }
    .zhedie-button {
        width:6px;
        margin:0px;
        padding: 11px 0px ;
        color: #4a8587;
        background: #f2f2f2;
        font-size: 16px;
        outline: none;
        cursor: pointer;
        text-align: center;
        line-height:38px;
    }
    .zhedie-button:hover {
        background: #f6e3ac;
        pointer-events:auto;
    }
    .dp-left-button {
        padding-right: 0;
        margin-right: 0px;
        text-align: center;
        line-height:36px;
        position: relative;
        color: #016277;
        outline: none;
        cursor: pointer;
        height: 36px;
        width:20px;
    }

    .dp-left-button:hover {
        background: #d3d3d3
    }
    .dp-right-button {
        text-align: center;
        line-height:36px;
        font-size: 15px;
        position: relative;
        color: #016277;
        outline: none;
        cursor: pointer;
        height: 36px;
        width:15px;
    }
    .dp-right-button:hover {
        background: #d3d3d3
    }
    .select_item{
        font-size: 9px;
    }



</style>